import { Drawer } from '@mui/material';
import { DRAWER_WIDTH } from '../Menu';

export default function DrawerDesktopMenu({ open, children }) {
  return (
    <Drawer
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
        },
      }}
      variant='persistent'
      anchor='left'
      open={open}
    >
      {children}
    </Drawer>
  );
}
